import React from 'react';

const FeatureBox = ({ icon, title, description }) => {
  return (
    <div className="feature-box">
      <div className="feature-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default FeatureBox;
